import React, { useState } from 'react';
import '../styles/Contact.css';

const Contact = () => {
  // Phone and WhatsApp numbers
  const phoneNumber = '+918019472678';
  const whatsappNumber = '918019472678';
  const emailAddress = 'info@hotelsinhyderabad.com';

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [formStatus, setFormStatus] = useState({
    submitted: false,
    success: false,
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Simple validation
    if (!formData.name || !formData.email || !formData.message) {
      setFormStatus({
        submitted: true,
        success: false,
        message: 'Please fill in all required fields.'
      });
      return;
    }

    // Here you would typically send the form data to your backend
    // For now, we'll just show a success message
    setFormStatus({
      submitted: true,
      success: true,
      message: 'Thank you! We will get back to you shortly.'
    });

    // Reset form after 3 seconds (optional)
    setTimeout(() => {
      setFormStatus({
        submitted: false,
        success: false,
        message: ''
      });
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
    }, 5000);
  };

  // Handle phone call
  const handleCall = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  // Handle WhatsApp chat
  const handleWhatsApp = () => {
    const message = 'Hi! I want to book a room at AA GRAND HOTEL.';
    window.open(
      `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`,
      '_blank'
    );
  };

  const contactInfo = [
    {
      icon: '📞',
      title: 'Call Us',
      details: [phoneNumber, 'Available 24/7 for bookings'],
      action: `tel:${phoneNumber}`,
      actionLabel: 'Call Now',
      onClick: handleCall
    },
    {
      icon: '💬',
      title: 'WhatsApp',
      details: ['Chat with us for quick responses', 'Instant booking confirmation'],
      action: `https://wa.me/${whatsappNumber}?text=${encodeURIComponent('Hi! I want to book a room at AA GRAND HOTEL.')}`,
      actionLabel: 'Chat Now',
      onClick: handleWhatsApp,
      isExternal: true
    },
    {
      icon: '📍',
      title: 'Visit Us',
      details: [
        'Ameerpet Metro Pillar No. 1072',
        'Above Bata Showroom, First Floor',
        'Hyderabad, Telangana'
      ],
      action: 'https://maps.google.com/maps?q=Ameerpet+Metro+Pillar+No+1072+Hyderabad',
      actionLabel: 'Get Directions',
      isExternal: true
    },
    {
      icon: '📧',
      title: 'Email Us',
      details: [emailAddress, 'We respond within 24 hours'],
      action: `mailto:${emailAddress}`,
      actionLabel: 'Send Email'
    }
  ];

  return (
    <div className="cnt-page-wrapper">
      {/* Hero Banner */}
      <div className="cnt-hero-section">
        <div className="cnt-hero-overlay">
          <div className="cnt-hero-content">
            <span className="cnt-hero-badge">✦ Contact Us</span>
            <h1 className="cnt-hero-title">
              Get In <span className="cnt-hero-highlight">Touch</span>
            </h1>
            <p className="cnt-hero-subtitle">
              We'd love to hear from you. Reach out to us anytime!
            </p>
          </div>
        </div>
      </div>

      {/* Contact Content */}
      <div className="cnt-content-section">
        <div className="cnt-container">
          {/* Contact Info Cards */}
          <div className="cnt-info-grid">
            {contactInfo.map((info, index) => (
              <div className="cnt-info-card" key={index}>
                <div className="cnt-info-icon">{info.icon}</div>
                <h3>{info.title}</h3>
                {info.details.map((detail, i) => (
                  <p key={i}>{detail}</p>
                ))}
                {info.onClick ? (
                  <button onClick={info.onClick} className="cnt-info-btn">
                    {info.actionLabel} →
                  </button>
                ) : (
                  <a 
                    href={info.action} 
                    className="cnt-info-btn"
                    target={info.isExternal ? '_blank' : '_self'} 
                    rel={info.isExternal ? "noopener noreferrer" : ""}
                  >
                    {info.actionLabel} →
                  </a>
                )}
              </div>
            ))}
          </div>

          {/* Form and Map Section */}
          <div className="cnt-form-map-wrapper">
            {/* Contact Form */}
            <div className="cnt-form-section">
              <div className="cnt-form-header">
                <span className="cnt-form-badge">✦ Send a Message</span>
                <h2 className="cnt-form-title">
                  We'd Love to <span className="cnt-highlight">Hear From You</span>
                </h2>
                <p className="cnt-form-subtitle">
                  Fill in the form below and we'll get back to you as soon as possible.
                </p>
              </div>

              <form className="cnt-form" onSubmit={handleSubmit}>
                <div className="cnt-form-row">
                  <div className="cnt-form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your full name"
                      required
                    />
                  </div>
                  <div className="cnt-form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      required
                    />
                  </div>
                </div>

                <div className="cnt-form-row">
                  <div className="cnt-form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Enter your phone number"
                    />
                  </div>
                  <div className="cnt-form-group">
                    <label htmlFor="subject">Subject</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      placeholder="Enter subject"
                    />
                  </div>
                </div>

                <div className="cnt-form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Write your message here..."
                    rows="5"
                    required
                  ></textarea>
                </div>

                {formStatus.submitted && (
                  <div className={`cnt-form-status ${formStatus.success ? 'cnt-success' : 'cnt-error'}`}>
                    {formStatus.message}
                  </div>
                )}

                <button type="submit" className="cnt-submit-btn">
                  Send Message →
                </button>
              </form>
            </div>

            {/* Map Section */}
            <div className="cnt-map-section">
              <div className="cnt-map-wrapper">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.123456789012!2d78.456789!3d17.456789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTfCsDI3JzI0LjQiTiA3OMKwMjcnMjQuMCJF!5e0!3m2!1sen!2sin!4v1234567890123"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="AA GRAND HOTEL Location"
                />
              </div>
              <div className="cnt-map-overlay">
                <div className="cnt-map-info">
                  <span className="cnt-map-icon">📍</span>
                  <div>
                    <h4>AA GRAND HOTEL</h4>
                    <p>Ameerpet Metro Pillar No. 1072,<br />Above Bata Showroom, Hyderabad</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;